export default __webpack_public_path__ + "static/media/yusra.660892ad.jpg";